import { httpClient } from "@/lib/http";

export type MediaKind = "avatar" | "image" | "audio";
export type UploadedMedia = { expiresAt: string; key: string; url: string };

export async function uploadMedia(source: Blob, kind: MediaKind): Promise<UploadedMedia> {
	const form = new FormData();
	const extension = kind === "audio" ? "webm" : "jpg";
	form.append("file", source, `${kind}.${extension}`);
	form.append("kind", kind);
	const response = await httpClient.post<UploadedMedia>("/media/upload", form);
	return response.data;
}

export async function uploadMediaReference(
	reference: string | null | undefined,
	kind: "image" | "audio",
): Promise<UploadedMedia | null> {
	if (!reference) return null;
	if (reference.startsWith("uploads/")) {
		const response = await httpClient.get<UploadedMedia>("/media/url", {
			params: { key: reference },
		});
		return response.data;
	}
	const blob = await fetch(reference).then((response) => {
		if (!response.ok) throw new Error("无法读取待上传媒体");
		return response.blob();
	});
	return uploadMedia(blob, kind);
}

export async function resolveMedia(
	reference: string,
): Promise<{ expiresAt?: string; url: string }> {
	if (!reference.startsWith("uploads/")) return { url: reference };
	const response = await httpClient.get<UploadedMedia>("/media/url", {
		params: { key: reference },
	});
	return response.data;
}
